import React from "react"
import classNames from "classnames";
import "./richText.scss"

const RichText = (props) => {
    const classnames = classNames("m-richText", {
        "m-richText--small": props.small,
        "m-richText--marg0": props.marg0,
        "m-richText--white": props.white,
        "m-richText--align-center": props.alignCenter,

        "m-richText--list-pad-left": props.listPadLeft,
    });
    let newText = props.content;
    return (
        <div className={props.className ? `${classnames} ${props.className}` : classnames}
             dangerouslySetInnerHTML={{ __html: newText }}
        />
    )
};

export default RichText;